// extracted by mini-css-extract-plugin
export default {"text":"text-a081","semibold":"semibold-73c1","h1":"h1-c6a8","h2":"h2-e805","h3":"h3-313e","body":"body-58e8","p1":"p1-60d1","p2":"p2-5c41"};